import { render } from "./RadiologyQueueTab.vue?vue&type=template&id=04483ecf"
import script from "./RadiologyQueueTab.vue?vue&type=script&lang=js"
export * from "./RadiologyQueueTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__